import React, { useMemo } from 'react';
import { motion, useReducedMotion } from 'framer-motion';

const COLORS = ['#FE5F1E', '#9900FF', '#0080FF', '#FFC23D', '#0F9D58', '#E0368F'];

/** One-shot confetti burst from the centre of its (relative) parent. */
const ConfettiBurst = ({ count = 34 }) => {
  const reduce = useReducedMotion();
  const pieces = useMemo(
    () =>
      Array.from({ length: count }, (_, i) => {
        const angle = (i / count) * Math.PI * 2 + (i % 2 ? 0.2 : -0.1);
        const dist = 90 + ((i * 37) % 80);
        return {
          id: i,
          x: Math.cos(angle) * dist,
          y: Math.sin(angle) * dist - 30,
          rotate: ((i * 73) % 360) - 180,
          color: COLORS[i % COLORS.length],
          w: i % 3 === 0 ? 6 : 8,
          h: i % 3 === 0 ? 6 : 12,
          round: i % 3 === 0,
          delay: (i % 5) * 0.02,
        };
      }),
    [count]
  );

  if (reduce) return null;

  return (
    <div aria-hidden="true" className="pointer-events-none absolute inset-0 z-20 overflow-visible">
      {pieces.map((p) => (
        <motion.span
          key={p.id}
          className="absolute left-1/2 top-1/2"
          style={{
            width: p.w,
            height: p.h,
            backgroundColor: p.color,
            borderRadius: p.round ? 999 : 2,
          }}
          initial={{ x: 0, y: 0, opacity: 1, rotate: 0, scale: 0.6 }}
          animate={{ x: p.x, y: [0, p.y, p.y + 70], opacity: [1, 1, 0], rotate: p.rotate, scale: 1 }}
          transition={{ duration: 1.1, ease: 'easeOut', delay: p.delay }}
        />
      ))}
    </div>
  );
};

export default ConfettiBurst;
